// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.phrase-editor .editor-pane {
  height: 100% !important;
  position: relative;
  outline: 0;
}
.phrase-editor .monaco-singleline {
  display: flex;
  align-items: center;
  position: relative;
}
.phrase-editor .monaco-singleline .decorationsOverviewRuler {
  display: none !important;
}
.phrase-editor .monaco-singleline .monaco-editor-background {
  top: 0 !important;
}
.phrase-editor .monaco-multiline {
  display: flex;
  align-items: flex-start;
  position: relative;
}
.phrase-editor .monaco-multiline .decorationsOverviewRuler {
  display: none !important;
}
.phrase-editor .monaco-multiline .scrollbar.vertical {
  width: 5px !important;
}
.phrase-editor .placeholder {
  position: absolute;
  left: 0;
  right: 0;
  overflow: hidden;
  line-height: 30px;
  padding-left: 5px;
  padding-right: inherit;
  cursor: text;
  -webkit-user-select: none;
     -moz-user-select: none;
          user-select: none;
  font-size: 12px;
  color: #999;
  font-style: italic;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
